import I18n from '@js/modules/translations';

// api.* never rejects: a failure resolves with `errors`, an interrupted request with `abort`
export const isFailure = (response) => !response || !!response.errors || !!response.abort;

// api.js already toasts a 500; an endpoint that notifies does it on its 422, the one failure without a status
export const needsErrorToast = (response, {serverNotifies = false} = {}) => {
    if (!response) {
        return true;
    }
    if (!response.errors || response.status === 500) {
        return false;
    }

    return !(serverNotifies && !response.status && !response.communication && response.errors !== 'offline');
};

// The server's own words, never a technical message nor an error page (5xx, HTML)
export const failureMessage = (response) => {
    if (response?.errors === 'offline') {
        return I18n.t('js.helpers.errors.no_network');
    }

    const errors = response?.errors;
    const isServerMessage = typeof errors === 'string' && !response.communication && !(response.status >= 500) && !/<[a-z!]/i.test(errors);

    return isServerMessage ? errors : I18n.t('js.helpers.errors.server');
};
